export default {
  title: "Actions",
  language: "Language",
  learnMore: "Learn More",
  showLess: "Show Less",
  save: "Save",
  send: "Send",
  saved: "Saved",
  add: "Add",
  create: "Create",
  createNew: "Create New",
  cancel: "Cancel",
  back: "Back",
  forward: "Forward",
  delete: "Delete",
  remove: "Remove",
  deleted: "Deleted",
  edit: "Edit",
  update: "Update",
  editInformation: "Edit Information",
  view: "View",
  open: "Open",
  manage: "Manage",
  manageEvents: "Manage Events",
  more: "More actions",
  search: "Search",
  close: "Close",
  continue: "Continue",
  retry: "Retry",
  refresh: "Refresh",
  reset: "Reset",
  expand: "Expand",
  collapse: "Collapse",
  confirm: "Confirm",
  invite: "Invite",
  verify: "Verify",
  verifying: "Verifying...",
  backToList: "Back to List",
  requestPasswordReset: "Request Password Reset",
  requestPasswordResetSent: "Request Password Reset Sent",
  resource: {
    add: "Add Resource",
  },
  project: {
    navigate: "Navigate to Project",
  },
  gantt: {
    show: "Show Gantt",
  },
  common: {
    duration: "Duration",
    translations: "Translations",
    language: "Language",
  },
  translation: {
    save: "Save translation",
  },
};
